import PropTypes from 'prop-types';
import withTypography from './withTypography';


const HeadingB = withTypography('h4', { className: 'ds-heading-b' });

HeadingB.defaultProps = {
  className: '',
};

// Also accepts all <h4 /> attributes
HeadingB.propTypes = {
  className: PropTypes.string,
};

export default HeadingB;



// WEBPACK FOOTER //
// ./src-react/DesignSystem/Typography/HeadingB.jsx